module.exports = __webpack_public_path__ + "37d7b009.png";